// Third-party
import React from 'react';

// Components
import { PrimaryButton } from '@/views/components/buttons';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  onGetStarted: () => void;
};

const HowItWorks: React.FC<Props> = (props: Props) => {
  const { onGetStarted } = props;

  return (
    <div className="how-it-works">
      <div className="container">
        <div className="header">{formatMessage('ComparisonHome.HowItWorks.Title')}</div>
        <div className="row">
          <div className="item">
            <span className="item-index">1</span>
            <div className="content">
              <div className="title">
                <i className="icon-import-into-capintel" />
                <span>{formatMessage('ComparisonHome.HowItWorks.Card1.Title')}</span>
              </div>
              <div className="description">{formatMessage('ComparisonHome.HowItWorks.Card1.Description')}</div>
            </div>
          </div>
          <div className="item">
            <span className="item-index">2</span>
            <div className="content">
              <div className="title">
                <i className="icon-select-compare" />
                <span>{formatMessage('ComparisonHome.HowItWorks.Card2.Title')}</span>
              </div>
              <div className="description">{formatMessage('ComparisonHome.HowItWorks.Card2.Description')}</div>
            </div>
          </div>
          <div className="item">
            <span className="item-index">3</span>
            <div className="content">
              <div className="title">
                <i className="icon-create-presentations" />
                <span>{formatMessage('ComparisonHome.HowItWorks.Card3.Title')}</span>
              </div>
              <div className="description">{formatMessage('ComparisonHome.HowItWorks.Card3.Description')}</div>
            </div>
          </div>
          <div className="item">
            <span className="item-index">4</span>
            <div className="content">
              <div className="title">
                <i className="icon-share-with-clients" />
                <span>{formatMessage('ComparisonHome.HowItWorks.Card4.Title')}</span>
              </div>
              <div className="description">{formatMessage('ComparisonHome.HowItWorks.Card4.Description')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="getting-started-action">
        <PrimaryButton onClick={onGetStarted} className="btn-get-started">
          {formatMessage('ComparisonHome.HowItWorks.GetStarted')}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default HowItWorks;
